/** Shared pagination defaults — mirrors backend PaginationConstants */
export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;

/**
 * Page size for the server-backed road autocomplete dropdown. Kept small so the
 * first page renders quickly; the dropdown fetches further pages on demand via
 * `useRoadSuggestions().loadMore()`.
 */
export const ROAD_SUGGESTIONS_PAGE_SIZE = 25;
